import api from "./api";

const UserService = {
  // getAllUsers: async (companyId) => {
  //   const res = await api.get("/users/getAll/" + companyId);
  //   return res.data.data;
  // },

  getAllUsers: async (companyId, search = "", page = 1, limit = 20) => {
    const res = await api.get(`/users/getAll/${companyId}`, {
      params: {
        search,
        page,
        limit
      }
    });

    return res.data; // ✅ return full response (data + pagination)
  },

  getServiceUsers: async (companyId, search = "") => {
    const res = await api.get(`/users/getServiceUsers/${companyId}?search=${search}`);
    return res.data;
  },
  getById: async (employeeId) => {
    const res = await api.get(`/users/getById/${employeeId}`);
    return res.data.data;
  },

  createUser: async (userData) => {
    const formData = new FormData();
    for (let key in userData) {
      formData.append(key, userData[key]);
    }
    return api.post("/users/save", formData).then(res => res.data);
  },

  updateUser: async (id, userData) => {
    const formData = new FormData();
    for (let key in userData) {
      formData.append(key, userData[key]);
    }
    return api.put(`/users/update/${id}`, formData).then(res => res.data);
  },

  deleteUser: async (id) => {
    const res = await api.delete(`/users/${id}`);
    return res.data;
  },

  // NEW: Toggle Active/Inactive Status
  toggleStatus: async (id) => {
    const res = await api.put(`/users/updatestatus/${id}`); // This should match backend route
    return res.data;
  },
  getUserMenu: async (employeeId, action) => {
    const res = await api.get(
      `users/getMenu?employeeId=${employeeId}&action=${action}`
    );
    return res.data;
  },

  updateUserMenu: async (menuData) => {
    const res = await api.post("/users/updateMenu", {
      data: menuData,
    });
    return res.data;
  },

  getReportingManagers: async (companyId) => {
    try {
      const res = await api.get(`/users/getReportingmanagers?companyId=${companyId}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching reporting managers:", error);
      return { status: false, data: [], message: error.message };
    }
  },

  resetPassword: async (employeeId, newPassword) => {
    try {
      const res = await api.post("/userLogin/resetPassword", {
        employeeId,
        newPassword,
      });
      return res.data;
    } catch (error) {
      console.error("Error resetting password:", error);
      return { success: false, message: "Error resetting password" };
    }
  },
  getNextEmployeeCode: async (companyId) => {
    try {
      const res = await api.get(`/users/getNextEmployeeCode/${companyId}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching next employee code:", error);
      return { status: false, data: "", message: error.message };
    }
  },

};

export default UserService;
